import React, { useMemo } from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import type { RootStackParamList } from '@/navigation/RootNavigator';
import { useThemeColors } from '@/hooks/residents/useThemeColors';
import { useResidentConversation } from '@/hooks/residents/useMessages';
import { ResidentChatWindowMobile } from '@/components/residents/propertyChat/mobile/ResidentChatWindowMobile';
import { UnifiedModal } from '@/components/common/UnifiedModal';

type Route = RouteProp<RootStackParamList, 'Conversation'>;

export const ConversationScreen: React.FC = () => {
  const navigation = useNavigation();
  const { params } = useRoute<Route>();
  const insets = useSafeAreaInsets();
  const { colors } = useThemeColors();
  const { conversation } = useResidentConversation(params.conversationId);

  const formattedCreatedAt = useMemo(() => {
    if (!conversation?.createdAt) return undefined;
    const date = new Date(conversation.createdAt);
    const dateStr = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
    const timeStr = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short',
    });
    return `${dateStr} ${timeStr}`;
  }, [conversation?.createdAt]);

  const handleClose = () => {
    navigation.goBack();
  };

  const subject = conversation?.subject || params.subject || 'Conversation';

  return (
    <View style={{ flex: 1, paddingTop: insets.top, backgroundColor: colors.bg.modal }}>
      <UnifiedModal
        visible
        onClose={handleClose}
        variant="fullscreen"
        animateEntry={false}
        title={subject}
        subtitle={formattedCreatedAt}
        avoidKeyboard
        compensateKeyboardToolbar
        scrollable={false}
      >
        <ResidentChatWindowMobile conversationId={params.conversationId} />
      </UnifiedModal>
    </View>
  );
};

export default ConversationScreen;
